if (!customElements.get('validation-modal')) {
  customElements.define(
    'validation-modal',
    class ValidationModal extends HTMLElement {
      constructor() {
        super();

        this.closeBtn = null;
      }

      connectedCallback() {
        this.closeBtn = this.querySelector('.close-modal');

        if (this.closeBtn) this.closeBtn.addEventListener('click', this.closeModal.bind(this));
        window.addEventListener('keydown', this.handleKeyDown.bind(this));
      }

      closeModal() {
        this.classList.add('hidden');
      }

      handleKeyDown(event) {
        if (event.key === 'Escape') {
          this.closeModal();
        }
      }

      openModal() {
        this.classList.remove('hidden');
        setTimeout(() => {
          this.classList.add('hidden');
        }, 5000);
      }
    }
  );
}
